
<div class="filters-row" style="display: flex;  gap: 16px">
  <div class="filter-container">
    <label class="filter-label">{{ formatLabel(data?.name) }}</label>

    <!-- Button/tile mode: every option is an always-visible filter button.
         Same `selected` model + onChange path as the ng-select below — only
         the input surface differs. "All" = empty selection = filter cleared. -->
    <div
      *ngIf="isButtonMode"
      class="gd-button-group"
      [class.gd-tiles]="displayMode === 'tiles'"
      [class.gd-disabled]="data?.disabled === true"
    >
      <button
        type="button"
        class="gd-option-btn gd-all-btn"
        [class.gd-active]="isAllActive"
        [disabled]="data?.disabled === true"
        (click)="onAllButtonClick()"
      >All</button>
      <button
        *ngFor="let item of options"
        type="button"
        class="gd-option-btn"
        [class.gd-active]="isItemSelected(item)"
        [disabled]="data?.disabled === true"
        [title]="formatOption(item)"
        (click)="onOptionButtonClick(item)"
      >{{ formatOption(item) }}</button>
    </div>

    <!-- closeOnSelect: a SINGLE-select is finished the moment you pick a value,
         so the panel should close itself. Multi-select stays open so you can
         tick several without reopening it each time. (This was hardcoded false,
         which left single-selects open until you clicked elsewhere.) -->
    <ng-select *ngIf="!isButtonMode" class="global-dropdown-select" [class.is-open]="isDropdownOpen" appendTo="body" ngClass="ss-dropdown-panel" [items]="filteredOptions" [multiple]="data?.isMultiSelect" [closeOnSelect]="!data?.isMultiSelect" [(ngModel)]="selected"
      [searchable]="false" [clearable]="!data?.disabled" [disabled]="data?.disabled === true" [placeholder]="placeholderText" (change)="onChange($event)" (open)="onDropdownOpen()" (close)="onDropdownClose()">
      <ng-template ng-header-tmp>
        <div class="custom-header">
          <!-- Search input -->
          <div class="search-wrapper">
            <!-- <mat-icon class="search-icon" fontIcon="search"></mat-icon> -->
            <input type="text" class="search-input" placeholder="Search" [formControl]="searchCtrl" (keydown)="$event.stopPropagation()"/>
          </div>


        <div class="custom-option" *ngIf="data?.isMultiSelect">
          <input type="checkbox" id="select-all" [checked]="isAllSelected" (change)="toggleSelectAll($event)" />
          <label for="select-all">&nbsp;Select All</label>
        </div>
      </div>
    </ng-template>

    <!-- Closed-control label (single-select). REQUIRED, not cosmetic: our options
         are plain strings, and ng-select derives its own label via
         resolveNested(item, bindLabel) with bindLabel defaulting to 'label' —
         "73022.02".label is undefined, so its built-in label renders as an empty
         chip. Printing the raw value ourselves is what makes the selection
         visible. (Multi-select is covered by ng-multi-label-tmp below.) -->
    <ng-template ng-label-tmp let-item="item">
      <span class="ng-value-label">{{ formatOption(item) }}</span>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div [title]="formatOption(item)" (click)="onItemClick(item)">
        <input id="item-{{ index }}" type="checkbox" [checked]="isItemSelected(item)" [matTooltip]="formatOption(item)"
          matTooltipPosition="right" />
        {{ formatOption(item) }}
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="custom-multi-label-wrapper">
        <ng-container *ngIf="items?.length > 0">
          <div class="ng-value">
            <span class="ng-value-icon left" (click)="clear(items[0])">×</span>
            <span class="ng-value-label">
              {{ formatOption(items[0]) }}
            </span>
          </div>
        </ng-container>
        <span class="tag-summary" *ngIf="items?.length > 1">
          +{{ items.length - 1 }} more
        </span>
      </div>
    </ng-template>

  </ng-select>
</div>
